export default __webpack_public_path__ + "static/media/prensesselin4.084804dd.jpg";